<div class="inspection-page">
  @switch (store.status()) {
    @case ('loading') {
      <p>Loading your inspection...</p>
    }
    @case ('ready') {
      @switch (store.request()?.productId) {
        @case (rcipProductId) {
          <app-rcip-wizard />
        }
        @default {
          <div class="wizard-panel">
            <p class="bold">This inspection can't be shown here yet.</p>
          </div>
        }
      }
    }
    @case ('signedOut') {
      <div class="wizard-panel">
        <p class="bold">Open your email link to continue</p>
        <p>For your security, use the link in your Coverage Validator email to get back to your inspection.</p>
      </div>
    }
    @case ('notFound') {
      <div class="wizard-panel">
        <p class="bold">Inspection not found</p>
        <p>Use the link in your most recent Coverage Validator email.</p>
      </div>
    }
    @case ('completed') {
      <div class="wizard-panel">
        <p class="bold">Inspection submitted</p>
        <p>Thank you for confirming your information. There's nothing more you need to do.</p>
      </div>
    }
    @case ('closed') {
      <div class="wizard-panel">
        <p class="bold">Link expired</p>
        <p>This link has expired. Please contact your agent.</p>
      </div>
    }
    @default {
      <div class="wizard-panel">
        <p class="bold">Something went wrong</p>
        <p>We couldn't load your inspection. Please try again in a few minutes.</p>
      </div>
    }
  }
</div>
